import React, { useState, useEffect } from "react";
import moment from "moment";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { isEmpty } from "lodash";
const DateRangePicker = ({ onApply, setShow, fromPeriod, toPeriod }) => {
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [selectMode, setSelectMode] = useState("start");

  const [startDate, setStartDate] = useState(
    !isEmpty(fromPeriod)
      ? moment(fromPeriod).startOf("day")
      : moment().startOf("day")
  );
  const [endDate, setEndDate] = useState(
    !isEmpty(toPeriod)
      ? moment(toPeriod).startOf("day")
      : moment().startOf("day")
  );

  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [second, setSecond] = useState(0);

  const daysInMonth = currentMonth.daysInMonth();
  const firstDayIndex = currentMonth.startOf("month").day(); // 0=Sunday

  // -------------------------------------------
  // Generate Calendar Days
  // -------------------------------------------
  const generateDays = () => {
    const days = [];

    // previous filler
    for (let i = 0; i < firstDayIndex; i++) {
      days.push({
        value: currentMonth
          .clone()
          .subtract(1, "month")
          .date(daysInMonth - firstDayIndex + i + 1),
        disabled: true,
      });
    }

    // active month
    for (let i = 1; i <= daysInMonth; i++) {
      const day = currentMonth.clone().date(i);
      days.push({
        value: day,
        disabled: day.isAfter(today, "day"), // disable future dates
      });
    }

    // next filler to reach 42 tiles
    while (days.length < 42) {
      days.push({
        value: currentMonth
          .clone()
          .add(1, "month")
          .date(days.length - (daysInMonth + firstDayIndex) + 1),
        disabled: true,
      });
    }

    return days;
  };

  // -------------------------------------------
  // Handle Day Click
  // -------------------------------------------
  const handleDayClick = (day) => {
    if (day.disabled) return;

    if (selectMode === "start") {
      setStartDate(day.value.clone().hour(hour).minute(minute).second(second));
      setSelectMode("end");
    } else {
      if (day.value.isBefore(startDate, "day")) {
        // if end < start => reset start
        setStartDate(day.value.clone().hour(0).minute(0).second(0));
      }
      setEndDate(day.value.clone().hour(23).minute(59).second(59));
      setSelectMode("start");
    }
  };

  // -------------------------------------------
  // Time Change
  // -------------------------------------------
  useEffect(() => {
    if (selectMode === "start") {
      setStartDate((prev) =>
        prev.clone().hour(hour).minute(minute).second(second)
      );
    } else {
      setEndDate((prev) =>
        prev.clone().hour(hour).minute(minute).second(second)
      );
    }
  }, [hour, minute, second]);

  // -------------------------------------------
  // Buttons
  // -------------------------------------------
  const handleClear = () => {
    setStartDate(moment().startOf("day"));
    setEndDate(moment().endOf("day"));
    setHour(0);
    setMinute(0);
    setSecond(0);
  };

  const handleApply = () => {
    onApply(startDate, endDate);
    setShow({
      type: "",
      status: false,
    });
  };
  const today = moment();

  const canGoNextMonth = currentMonth.isBefore(today, "month");
  return (
    <div className="date-picker-content">
      <div className="btn-clear-date" onClick={handleClear}>
        Clear
      </div>

      <div className="date-picker-title">
        <div className="picker-start-date active-item">
          {startDate.format("MM/DD HH:mm:ss")}
        </div>
        <div> - </div>
        <div className="picker-start-date ">
          {endDate.format("MM/DD HH:mm:ss")}
        </div>
      </div>

      {/* Month Header */}
      <div className="date-picker-warp">
        <div className="date-picker-month">
          <div
            className="btn-next-prev"
            onClick={() =>
              setCurrentMonth((prev) => prev.clone().subtract(1, "month"))
            }
          >
            <IoIosArrowBack />
          </div>

          <div className="picker-month">
            {currentMonth.format("MMM")} &nbsp;&nbsp;&nbsp;{" "}
            {currentMonth.format("YYYY")}
          </div>

          <div
            className={`btn-next-prev ${!canGoNextMonth ? "disable-item" : ""}`}
            onClick={() => {
              if (canGoNextMonth) {
                setCurrentMonth((prev) => prev.clone().add(1, "month"));
              }
            }}
          >
            <IoIosArrowForward />
          </div>
        </div>

        {/* Week Row */}
        <div className="date-picker-week">
          {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((d) => (
            <div key={d} className="pickter-item week-item">
              {d}
            </div>
          ))}
        </div>

        {/* Days Grid */}
        <div className="date-picker-days">
          {generateDays().map((day, i) => {
            const isStart = day.value.isSame(startDate, "day");
            const isEnd = day.value.isSame(endDate, "day");
            const isBetween =
              day.value.isAfter(startDate, "day") &&
              day.value.isBefore(endDate, "day");

            return (
              <div
                key={i}
                className={`pickter-item
          ${day.disabled ? "disable-item" : ""} 
          ${isStart ? "active-item start-item" : ""}
          ${isEnd ? "active-item end-item" : ""}
          ${isBetween ? "through-item" : ""}
        `}
                onClick={() => handleDayClick(day)}
              >
                <span>{day.value.date()}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* TIME PICKER */}
      {/* <div className="date-picker-time">
        <div className="time-picker-item">
          <div className="item-col-text">hr</div>
          <div className="item-col-content">
            {Array.from({ length: 24 }).map((_, i) => (
              <div
                key={i}
                className={`time-col-item ${
                  i === hour ? "time-col-item-selected" : ""
                }`}
                onClick={() => setHour(i)}
              >
                {String(i).padStart(2, "0")}
              </div>
            ))}
          </div>
        </div>
        <div className="time-picker-item">
          <div className="item-col-text">min</div>
          <div className="item-col-content">
            {Array.from({ length: 60 }).map((_, i) => (
              <div
                key={i}
                className={`time-col-item ${
                  i === minute ? "time-col-item-selected" : ""
                }`}
                onClick={() => setMinute(i)}
              >
                {String(i).padStart(2, "0")}
              </div>
            ))}
          </div>
        </div>
        <div className="time-picker-item">
          <div className="item-col-text">sec</div>
          <div className="item-col-content">
            {Array.from({ length: 60 }).map((_, i) => (
              <div
                key={i}
                className={`time-col-item ${
                  i === second ? "time-col-item-selected" : ""
                }`}
                onClick={() => setSecond(i)}
              >
                {String(i).padStart(2, "0")}
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <div className="btn-confirm-date" onClick={handleApply}>
        OK
      </div>
    </div>
  );
};

export default DateRangePicker;
